import React, { Component } from "react";
import { Link, Redirect } from "react-router-dom";
import Table from "../adminDashboard/Table.js";
import Loader from "../../Loader.jsx";
import { toast, ToastContainer } from "mdbreact";
import DateTimePicker from "./DateTimePicker";
import {
  setServicios,
  delServicios,
  getCookie,
  getValoresXDominio,
  decodeToken,
  find,
  buscarCoincidencias,
  getServicios,
} from "../../functions.js";

import ReactExport from "react-export-excel-xlsx-fix";
const ExcelFile = ReactExport.ExcelFile;
const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;
const ExcelColumn = ReactExport.ExcelFile.ExcelColumn;

var fecNum = Date.now();
var fecNum2 = Date.now() + 1;

var f = new Date();
var fromDate = new Date();
fromDate.setDate(f.getDate() - 3);

var mes =
  f.getUTCMonth() + 1 < 10 ? "0" + (f.getUTCMonth() + 1) : f.getUTCMonth() + 1;
var dia = f.getUTCDate() < 10 ? "0" + f.getUTCDate() : f.getUTCDate();
var date_label = f.getUTCFullYear() + "." + mes + "." + dia;

class ManageServices extends Component {
  constructor(props) {
    super(props);
    this.state = {
      key: 1,
      serviciosOrig: [],
      action: "create",
      token_to_delete: "",
      date_label: date_label,
      loaded: false,
      id: 0,
      invalidForm: false,
      customerDocumentId: 0,
      RadioReservationType: 0,
      customerName: "",
      customerId: 0,
      filtro: "",
      redirect: false,
      productId: 0,
      birthDate: null,
      bookingName: "",
      estado: "ACTIVO",
      diaSemana: -1,
      lockInputs: false,
      buttonLabel: "Crear Servicio",
      products: [],
      id_consultorio: 0,
      consultorios: [],
      titulo: (
        <>
          {" "}
          <i className="fas fa-plus" /> Nuevo Servicio{" "}
        </>
      ),
      servicios: [],
      canales: [],
      canal: "",
      etiqueta1n: "Minuto",
      etiqueta2n: "Hora",
      etiqueta1a: "Fecha final",
      etiqueta2a: "Hora",
      validations: {
        servicio: false,
        id_consultorio: false,
        tipo: false,
        estado: false,
        fechaFin: false,
        fechaIni: false,
        diaSemana: false,
        horaIni1: false,
        horaIni2: false,
        horaFin1: false,
        horaFin2: false,
      },

      tableData: {
        columns: [
          {
            dataIndex: "id",
            title: "Action",
            render: (text, record) => (
              <>
                <div style={{ width: 70 }}>
                  <button
                    className="btn btn-sm btn-info"
                    id={record.codServInnova}
                    name="view"
                    onClick={this.editarServicio}
                    type="submit"
                  >
                    <i className="fas fa-edit" />
                  </button>

                  <button
                    className="btn btn-sm btn-danger"
                    id={record.codServInnova}
                    name="view"
                    onClick={this.eliminarServicio}
                    type="submit"
                  >
                    <i className="fas fa-trash" />
                  </button>
                </div>
              </>
            ),
          },

          { dataIndex: "descripcion_servicio", title: "Descripción Servivio" },
          { dataIndex: "estado", title: "Estado" },
          { dataIndex: "codSAP", title: "Código SAP" },
          { dataIndex: "es_virtual", title: "Cita virtual" },
          { dataIndex: "es_presencial", title: "Cita presencial" },
          { dataIndex: "duracion_consulta", title: "Duración de la consulta" },
        ],
        rows: [],
      },

      tipos: [
        { value: "RANGODIA", text: "Rango de días" },
        { value: "DIA", text: "Día específico" },
        { value: "DIASEMANA", text: "Día de la semana" },
        { value: "HORASEMANA", text: "Hora de la semana" },
        { value: "HORADIASEMANA", text: "Hora de un día de la semana" },
      ],

      activo: "1",

      descripcion_servicio: "",
      codSAP: "",
      es_virtual: "S",
      es_presencial: "S",
      duracion_consulta: "20",
      modal1: false,
    };
    this.handleSelect = this.handleSelect.bind(this);
  }

  editarServicio = async (event) => {
    let id = event.target.id;
    if (id === "") {
      id = event.target.parentNode.id;
    }

    let tipo = "";
    let pos = find(this.state.serviciosOrig, id, "codServInnova");
    let data = this.state.serviciosOrig[pos];
    console.log("DATA", data);
    for (let i in Object.keys(data)) {
      let field = Object.keys(data)[i];

      if (data[field] || data[field] === 0) {
        if (field === "fechaIni" || field === "fechaFin") {
          let fechaDate = new Date(data[field]);
          this.setState({
            [field]: fechaDate,
          });
          console.log(fechaDate);
        } else if (field === "horaIni" || field === "horaFin") {
          let hora = data[field].split(":");
          if (hora.length > 1) {
            this.setState({
              [field + "1"]: hora[0],
              [field + "2"]: hora[1],
            });
          } else {
            this.setState({
              [field + "1"]: "-",
              [field + "2"]: "-",
            });
          }
        } else if (field === "tipo") {
          tipo = data[field];
        } else {
          this.setState({
            [field]: data[field],
          });
        }
      } else {
        //console.log(field + " no hay", data[field]);
      }
    }

    this.setState({
      //validations: validations,
      action: "edit",
      buttonLabel: "Editar Servicio",
      lockInputs: true,
      id: id,
      titulo: (
        <>
          {" "}
          <i className="fas fa-edit" />
          Editar Servicio{" "}
        </>
      ),
      invalidForm: false,
    });
  };

  clearData = async (event) => {
    let validations = {};
    let titulo = (
      <>
        {" "}
        <i className="fas fa-plus" /> Nuevo Servicio{" "}
      </>
    );

    this.setState({
      validations: validations,
      action: "create",
      buttonLabel: "Crear Servicio",
      lockInputs: false,
      titulo: titulo,

      id: 0,
      descripcion_servicio: "",
      codSAP: "",
      es_virtual: "S",
      es_presencial: "S",
      duracion_consulta: "20",
    });
  };

  eliminarServicio = async (event) => {
    //console.log(this.state.action)
    //this.setState({ ...this.state, isExecuting: true });
    let id = event.target.id;
    if (id === "") {
      id = event.target.parentNode.id;
    }

    let pos = find(this.state.serviciosOrig, id, "codServInnova");
    let data = this.state.serviciosOrig[pos];

    if (data.DELETE_DATE) {
      toast.error("La servicio ya está inactiva", { closeButton: true });
    } else {
      let formData = {
        id: id,
        username: this.state.username,
      };
      var respI = await delServicios(formData);

      if (respI.success) {
        var resp = await getServicios();

        const tableData = this.state.tableData;
        tableData.rows = resp.servicios ? resp.servicios : [];

        this.setState({
          ...this.state,
          isExecuting: false,
          servicios: resp.servicios,
          serviciosOrig: resp.servicios,
        });
        this.clearData();
        this.filterData();
        toast.success("Se actualizó el estado a inactivo", {
          closeButton: true,
        });
      } else {
        toast.error(respI.messsage, { closeButton: true });
        this.setState({ ...this.state, isExecuting: false });
      }
    }
  };

  saveData = async (event) => {
    //console.log(this.state.action)

    let data = {
      descripcion_servicio: false,
      activo: false,
      codSAP: false,
      es_virtual: false,
      es_presencial: false,
      duracion_consulta: false,
    };

    let formData = {
      id: this.state.id,
      action: this.state.action,
    };

    var isValid = true;
    for (let i in Object.keys(data)) {
      let field = Object.keys(data)[i];
      //	console.log(field, this.state[field])

      //console.log(field)

      if (this.state[field] === "") {
        data[field] = true;
        isValid = false;
      } else {
        formData[field] = this.state[field];
      }
    }
    if (this.state.action === "create") {
    }

    if (isValid) {
      formData["username"] = this.state.username;

      this.setState({ ...this.state, isExecuting: true });

      var respI = await setServicios(formData);

      if (respI.success) {
        var resp = await getServicios();

        const tableData = this.state.tableData;
        tableData.rows = resp.servicios ? resp.servicios : [];

        this.setState({
          ...this.state,
          isExecuting: false,
          servicios: resp.servicios,
          serviciosOrig: resp.servicios,
        });
        this.clearData();
        this.filterData();
        toast.success("Datos registrados correctamente", { closeButton: true });
      } else {
        toast.error(respI.messsage, { closeButton: true });
        this.setState({ ...this.state, isExecuting: false });
      }
      //
    } else {
      this.setState({
        validations: data,
      });
    }
  };
  /*
  changeHandler = async (event) => {
    let value = event.target.value;
    let validations = this.state.validations;

    validations[event.target.name] = value.length === 0;

    this.setState({
      [event.target.name]: value,
      validations: validations,
    });
  };
*/
  filterData = (event) => {
    if (this.state.filtro.length > 3) {
      let resp = buscarCoincidencias(
        this.state.serviciosOrig,
        this.state.filtro,
        "descripcion_servicio"
      );
      console.log("r", resp);
      var tableData = this.state.tableData;
      tableData.rows = resp;

      this.setState({
        tableData: tableData,
      });
    }
  };

  refresh = (event) => {
    var tableData = this.state.tableData;
    tableData.rows = this.state.serviciosOrig;

    this.setState({
      tableData: tableData,
    });
  };

  changeHandler = async (event) => {
    let value = event.target.value;
    let name = event.target.name;
    let validations = this.state.validations;

    // Si el nombre del input es 'duracion_consulta', verifica si el valor ingresado es un número
    if (name === "duracion_consulta") {
      // Verifica si el valor ingresado no es un número
      if (!/^\d+$/.test(value)) {
        // Si no es un número, no actualices el estado y detén la ejecución
        return;
      }
    }

    // Actualiza el estado con el nuevo valor y las validaciones
    this.setState({
      [name]: value,
      validations: {
        ...validations,
        [name]: value.length === 0,
      },
    });

    if (event.key === "Enter" && name === "filtro") {
      // Lógica a ejecutar cuando se presiona Enter
      if (value && value.length > 3) {
        this.filterData();
      }
    }
  };

  handleSelect(key) {
    this.setState({ key });
  }
  onClickRadioReservationType = (nr, serviceId, key) => () => {
    this.setState({
      ...this.state,
      RadioReservationType: nr,
    });
    const bookings = this.state.bookings;
    for (var i in bookings) {
      if (bookings[i].codServInnova === serviceId) {
        bookings[i].llaves[key].serviceType = nr;
      }
    }
  };

  componentDidMount = async () => {
    this.setState({ isExecuting: true });
    let token = getCookie("tokenINNOVA2");

    let esAdmin = true;
    var _resp;
    if (!token) {
      esAdmin = false;
    } else {
      _resp = await decodeToken(token);
      if (_resp.datos.rol !== "Administrador") {
        console.log("no permitido");
        esAdmin = false;
      }
    }

    if (!esAdmin) {
      this.setState({ redirect: true, isExecuting: false });
    } else {
      let username = getCookie("nombreUsuarioINNOVA2");

      let resp = await getServicios();

      var userInfo = _resp.datos;
      this.setState({ userInfo: userInfo, username: username });

      var canal = userInfo.canal;
      var canales = [];

      const tableData = this.state.tableData;
      tableData.rows = resp.servicios ? resp.servicios : [];

      var respC = await getValoresXDominio("canales");

      var horas = [];

      horas.push({ text: "-", value: "-" });
      for (let i = 0; i < 24; i++) {
        var hora = ("0" + i).slice(-2); // Agrega un cero delante si es necesario
        horas.push({ text: hora, value: hora });
      }
      var minutos = [];
      minutos.push({ text: "-", value: "-" });
      for (let i = 0; i < 60; i += 5) {
        var minuto = ("0" + i).slice(-2); // Agrega un cero delante si es necesario
        minutos.push({ text: minuto, value: minuto });
      }

      this.setState({
        ...this.state,
        loaded: true,
        horas: horas,
        minutos: minutos,
        servicios: resp.servicios,
        serviciosOrig: resp.servicios,
        canales: canales,
        canal: canal,
        //servicios: servicios,
        //servicio:servicio,
        isExecuting: false,
      });
    }
  };
  toggleM = (nr) => () => {
    this.setState({
      ["modal" + nr]: !this.state["modal" + nr],
    });
  };

  render() {
    return (
      <>
        {this.state.redirect ? <Redirect to={{ pathname: "/" }} /> : ""}

        <div>
          <div className="breadcrumb-bar">
            <div className="container-fluid">
              <div className="row align-items-center">
                <div className="col-md-12 col-12">
                  <nav aria-label="breadcrumb" className="page-breadcrumb">
                    <ol className="breadcrumb">
                      <li className="breadcrumb-item">
                        <Link to="/home">Inicio</Link>
                      </li>
                    </ol>
                  </nav>
                  <h2 className="breadcrumb-title">
                    Administraci&oacute;n de Servicios
                  </h2>
                </div>
              </div>
            </div>
          </div>
          <Loader idLoading={this.state.isExecuting} />

          <div className="content">
            <ToastContainer
              hideProgressBar={true}
              newestOnTop={false}
              position={"bottom-right"}
              autoClose={3000}
            />
            <div className="container-fluid">
              <div className="row">
                <div className="col-md-6 col-lg-5 col-xl-4 theiaStickySidebar">
                  <div className="row">
                    <div className="col-12">
                      <div className="col-12">
                        <span className="h3-responsive ">
                          {this.state.titulo}
                        </span>
                      </div>
                    </div>
                  </div>
                  <span className="or-line" />
                  <div className="row">
                    <div className="col-12">
                      <div className="form-group mini-margin card-label">
                        <label>Descripción Servivio</label>
                        <input
                          name="descripcion_servicio"
                          disabled={this.state.lockInputs}
                          className={
                            "form-control " +
                            (this.state.validations.descripcion_servicio
                              ? "is-invalid"
                              : "")
                          }
                          type="text"
                          value={this.state.descripcion_servicio}
                          onChange={this.changeHandler}
                        />
                      </div>
                    </div>
                  </div>

                  <div className="row">
                    <div className="col-6">
                      <div className="form-group mini-margin card-label">
                        <label>Cita virtual </label>
                        <select
                          className={
                            " browser-default custom-select form-control " +
                            (this.state.validations.es_virtual
                              ? "is-invalid"
                              : "")
                          }
                          name="es_virtual"
                          onChange={this.changeHandler}
                          defaultValue={this.state.es_virtual}
                          value={this.state.es_virtual}
                        >
                          <option value="S">SI</option>
                          <option value="N">NO</option>
                        </select>
                      </div>
                    </div>
                    <div className="col-6">
                      <div className="form-group mini-margin card-label">
                        <label>Cita presencial </label>
                        <select
                          name="es_presencial"
                          className={
                            " browser-default custom-select form-control " +
                            (this.state.validations.es_presencial
                              ? "is-invalid"
                              : "")
                          }
                          onChange={this.changeHandler}
                          value={this.state.es_presencial}
                          defaultValue={this.state.es_presencial}
                        >
                          <option value="S">SI</option>
                          <option value="N">NO</option>
                        </select>
                      </div>
                    </div>
                  </div>

                  <div className="row">
                    <div className="col-6">
                      <div className="form-group mini-margin card-label">
                        <label>Código SAP</label>
                        <input
                          name="codSAP"
                          className={
                            "form-control " +
                            (this.state.validations.codSAP ? "is-invalid" : "")
                          }
                          type="text"
                          value={this.state.codSAP}
                          onChange={this.changeHandler}
                        />
                      </div>
                    </div>
                    <div className="col-6">
                      <div className="form-group mini-margin card-label">
                        <label>Duración de la consulta</label>
                        <input
                          name="duracion_consulta"
                          className={
                            "form-control " +
                            (this.state.validations.duracion_consulta
                              ? "is-invalid"
                              : "")
                          }
                          type="text"
                          value={this.state.duracion_consulta}
                          onChange={this.changeHandler}
                        />
                      </div>
                    </div>
                  </div>

                  <div className="row mt-3 mb-3">
                    <div className="col-6">
                      <div className="form-group mini-margin card-label">
                        <button
                          className="btn btn-danger btn-block"
                          name="search"
                          onClick={this.clearData}
                          type="submit"
                        >
                          Limpiar Datos
                        </button>
                      </div>
                    </div>

                    <div className="col-6">
                      <div className="form-group mini-margin card-label">
                        <button
                          className="btn btn-primary btn-block"
                          name="search"
                          onClick={this.saveData}
                          disabled={this.state.invalidForm}
                          type="submit"
                        >
                          {this.state.buttonLabel}
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
                <div id="atenciones" className="col-md-6 col-lg-7 col-xl-8">
                  <div className="card">
                    <div className="card-body pt-0">
                      <div className="row">
                        <div
                          id="results"
                          className="col-6 col-lg-4 text-right mb-2 mt-3"
                          style={{ padding: 0, display: "flex" }}
                        >
                          <input
                            name="filtro"
                            className={"search-input"}
                            type="text"
                            onKeyDown={this.changeHandler}
                            placeholder="Desc servicio"
                            value={this.state.filtro}
                            onChange={this.changeHandler}
                          />
                          <button
                            className="btn btn-sm btn-secondary btn-block"
                            name="search"
                            disabled={this.state.filtro.length <= 3}
                            onClick={this.filterData}
                            type="submit"
                          >
                            Buscar
                          </button>

                          <button
                            className="btn btn-sm btn-warning"
                            name="view"
                            onClick={this.refresh}
                            type="submit"
                          >
                            <i className="fas fa-sync" />
                          </button>
                        </div>
                        <div
                          id="results"
                          className="col-6 col-lg-8 text-right mb-2 mt-3"
                          style={{ padding: 0 }}
                        >
                          <ExcelFile
                            filename={"export-ordenes." + this.state.date_label}
                            element={
                              <button
                                disabled={this.state.tableData.rows.length == 0}
                                type="button"
                                className="btn btn-sm btn-success"
                                name="set"
                              >
                                {" "}
                                Exportar
                              </button>
                            }
                          >
                            <ExcelSheet
                              data={this.state.tableData.rows}
                              name="ordenes"
                            >
                              <ExcelColumn
                                label="Nombre Servicio"
                                value="servicio"
                              />
                              <ExcelColumn
                                label="Tipo de Servicio"
                                value="tipo"
                              />
                              <ExcelColumn
                                label="Fecha de inicio"
                                value="fechaIni"
                              />
                              <ExcelColumn
                                label="Apellido Materno"
                                value="fechaFin"
                              />
                              <ExcelColumn
                                label="Hora de inicio"
                                value="horaIni"
                              />
                              <ExcelColumn
                                label="Fecha final"
                                value="horaFin"
                              />

                              <ExcelColumn
                                label="Dia de la semana"
                                value="diaSemana"
                              />
                              <ExcelColumn label="Estado" value="estado" />
                            </ExcelSheet>
                          </ExcelFile>
                        </div>
                      </div>

                      <Table tableData={this.state.tableData} />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </>
    );
  }
}
export default ManageServices;
